import { FAVICON } from "../constants";
import CryptoTool from "./CryptoTool";
import API from "./API";

const shopUrl = CryptoTool.getShopUrl();
const DefaultUser = CryptoTool.getDefaultUser();

const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
//Change cutOffDeliveryHour when there is difference between EST and EDT
// 11 - summer time
// 12 - winter time
const cutOffDeliveryHour = 11;

const shortMonthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const holidayDates = ["12-25", "1-1"];

/**
 * Get Selling Plan from subscription products
 * @param { string } title
 * @returns { * } sellingPlanFirstId
 */
export const getSellingPlan = (title) => {
  const { MHBundlesCollections } = window;
  if (typeof MHBundlesCollections === "undefined") return null;
  const findSellingPlan = MHBundlesCollections.find((item) => title === item.title);
  return findSellingPlan?.sellingPlanFirstId;
};

export const getSellingProgramSellingPlan = (dietType) => {
  const { MHProductsCollections } = window;
  const programTitle = dietType.split(' ')[0];
  if (typeof MHProductsCollections === "undefined") return null;
  const findSellingPlan = MHProductsCollections.find(({title}) => title.includes(programTitle));

  return findSellingPlan?.sellingPlanFirstId;
};

/**
 * Adjust date is it is Friday and it is holiday
 * @param {date} date - date of the order or an upcoming charge
 */
const adjustDate = (dateObj) => {
  var newDate = dateObj;
  var month = new Date(newDate).getMonth() + 1;
  var date = new Date(newDate).getDate();
  var day = new Date(newDate).getDay();
  var formattedDate = month + "-" + date;

  if (day === 5 && holidayDates.includes(formattedDate)) {
    newDate.setDate(newDate.getDate() - 1);
  }
  return newDate;
};
/**
 * To adjust delivery date on some days forward
 * @param {date} date - date of the order or an upcoming charge
 */
const applyAdjustDate = (date) => {
  let newDate = date;

  let adjustmentValue = parseInt(typeof window.theme.dateAdjustment === "undefined" ? 0 : window.theme.dateAdjustment);
  const dietType = document.getElementById("diet_type");
  if (dietType !== null && dietType.innerHTML === "Mediterranean") {
    adjustmentValue = parseInt(
      typeof window.theme.dateAdjustmentMediterranean === "undefined" ? 0 : window.theme.dateAdjustmentMediterranean
    );
  }

  if (adjustmentValue) {
    newDate.setDate(newDate.getDate() + adjustmentValue);
  }

  return newDate;
};

/**
 * Calculate delivery date according to user local time, adjusted to UTC-4 time zone
 */
export const calculateDeliveryDateFromNow = () => {
  const currentDate = new Date();

  //Adjust user local time to UTC-4 time zone
  const hoursOffset = currentDate.getTimezoneOffset() / 60 - 5;
  currentDate.setHours(currentDate.getHours() + hoursOffset);
  let scheduledAtDate = currentDate;
  const getHours = currentDate.getHours();
  const getWeekDay = scheduledAtDate.getDay();

  //If it is Monday from 0AM till 5AM, then delivery will be this week Friday
  if (getHours >= 0 && getHours < cutOffDeliveryHour && getWeekDay === 1) {
    scheduledAtDate.setDate(scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + 4);
  } else {
    scheduledAtDate.setDate(scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + 11);
  }

  scheduledAtDate = adjustDate(scheduledAtDate);
  scheduledAtDate = applyAdjustDate(scheduledAtDate);

  const day = new Date(scheduledAtDate).getDay();
  const month = new Date(scheduledAtDate).getMonth();
  const date = new Date(scheduledAtDate).getDate();

  return weekDays[day] + ", " + shortMonthNames[month] + " " + date;
};

/**
 * Calculate delivery date
 * @param {string} scheduledAt - date of the order or an upcoming charge
 */
export const calculateDeliveryDate = (scheduledAt, type) => {
  if (typeof scheduledAt !== "undefined") {
    let scheduledAtDate = new Date(scheduledAt);
    const getHours = scheduledAtDate.getHours();
    const getWeekDay = scheduledAtDate.getDay();

    //If it is Monday from 0AM till 5AM, then delivery will be this week Friday
    if (getHours >= 0 && getHours < cutOffDeliveryHour && getWeekDay === 1) {
      scheduledAtDate.setDate(scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + 4);
    } else {
      scheduledAtDate.setDate(scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + 11);
    }

    scheduledAtDate = adjustDate(scheduledAtDate);
    scheduledAtDate = applyAdjustDate(scheduledAtDate);

    const day = new Date(scheduledAtDate).getDay();
    const month = new Date(scheduledAtDate).getMonth();
    const date = new Date(scheduledAtDate).getDate();

    if (type === "short") {
      return weekDays[day] + ", " + shortMonthNames[month] + " " + date;
    } else {
      return weekDays[day] + ", " + monthNames[month] + " " + date;
    }
  }
};

/**
 * Calculate scheduled date
 * @param {string} scheduledAt - date of an upcoming charge based on the order (processed) date if exists
 */
export const calculateScheduledDate = (scheduledAt, processedAt, type) => {
  if (typeof scheduledAt !== "undefined") {
    let scheduledAtDate = new Date(processedAt ? processedAt : scheduledAt);
    const getHours = scheduledAtDate.getHours();
    const getWeekDay = scheduledAtDate.getDay();

    //If it is Monday from 0AM till 5AM, then delivery will be this week Friday
    if (getHours >= 0 && getHours < cutOffDeliveryHour && getWeekDay === 1) {
      scheduledAtDate.setDate(
        scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + (processedAt ? 11 : 4)
      );
    } else {
      scheduledAtDate.setDate(
        scheduledAtDate.getDate() - scheduledAtDate.getDay() + (scheduledAtDate.getDay() === 0 ? -6 : 1) + (processedAt ? 18 : 11)
      );
    }

    scheduledAtDate = adjustDate(scheduledAtDate);
    scheduledAtDate = applyAdjustDate(scheduledAtDate);

    const day = new Date(scheduledAtDate).getDay();
    const month = new Date(scheduledAtDate).getMonth();
    const date = new Date(scheduledAtDate).getDate();

    if (type === "short") {
      return weekDays[day] + ", " + shortMonthNames[month] + " " + date;
    } else {
      return weekDays[day] + ", " + monthNames[month] + " " + date;
    }
  }
};

/**
 * Calculate current week Friday date
 * @param {string} scheduledAt - date of the order or an upcoming charge
 */
export const calculateCurrentWeekFridayDate = (scheduledAt) => {
  const scheduledAtDate = new Date(scheduledAt);
  scheduledAtDate.setDate(scheduledAtDate.getDate() + ((1 + 7 - scheduledAtDate.getDay()) % 7) + 4 - 7);

  let day = new Date(scheduledAtDate).getDay();
  let month = new Date(scheduledAtDate).getMonth();
  let date = new Date(scheduledAtDate).getDate();

  return weekDays[day] + ", " + monthNames[month] + " " + date;
};

/**
 * Calculate charge edit limit date
 * @param {string} scheduledAt - date of the order or an upcoming charge
 */
export const calculateLimitEditDate = (scheduledAt) => {
  const scheduledAtDate = new Date(scheduledAt);
  const scheduledAtDateDate = scheduledAtDate.getDate();

  scheduledAtDate.setDate(scheduledAtDateDate - 1);

  const day = new Date(scheduledAtDate).getDay();
  const month = new Date(scheduledAtDate).getMonth();
  const date = new Date(scheduledAtDate).getDate();

  return weekDays[day] + ", " + monthNames[month] + " " + date;
};

/**
 * Round up money summ
 * @param {number} price - price of the Shopify product
 */
export const roundMoneyValue = (price) => {
  return (Math.round(price * 100) / 100).toFixed(2);
};

/**
 * Split meals onto brekfasts, lunches and entrees
 * @param {array} meals
 */
export const getMealsBreakdown = (meals) => {
  let data = {
    breakfasts: 0,
    entrees: 0,
    addIns: 0,
  };

  meals.forEach((meal) => {
    meal.tags.forEach((tag) => {
      let mealTag = tag.toLowerCase();
      if (mealTag === "breakfast") {
        data.breakfasts += 1;
      } else if (mealTag === "entrée") {
        data.entrees += 1;
      } else if (mealTag === "add-in") {
        data.addIns += 1;
      }
    });
  });

  return data;
};

/**
 * Mark new meals with the proper SubscriptionIds in order
 * to provide SubscriptionIds for new meals, passed to ReCharge API
 */
export const markNewMeals = (mealsBreakdown, savedMealsBreakdown, meals, oldMeals) => {
  let newMeals = [...meals];
  let oldMealsItems = [...oldMeals];

  //Get an existing subscription Id for paticular meal type
  const getSubscriptionId = (data, typeArr) => {
    let _newMeals = [...data];
    let subscriptionId;

    _newMeals.forEach((meal) => {
      meal.tags.forEach((tag) => {
        let mealTag = tag.toLowerCase();
        typeArr.forEach((type) => {
          if (mealTag === type && typeof meal.subscriptionId !== "undefined") subscriptionId = meal.subscriptionId;
        });
      });
    });

    return subscriptionId;
  };

  //Mark all new meals with subscription Id
  const markNewMealsSubscriptionId = (data) => {
    let _newMeals = [...data];
    let breakfastSubscriptionId;
    let entreeSubscriptionId;

    if (mealsBreakdown.breakfasts > 0) {
      breakfastSubscriptionId = getSubscriptionId(oldMealsItems, ["breakfast"]);
      _newMeals = markWithExisitingSubscriptionId(_newMeals, ["breakfast"], breakfastSubscriptionId);
    }

    if (mealsBreakdown.entrees > 0) {
      entreeSubscriptionId = getSubscriptionId(oldMealsItems, ["entrée"]);

      _newMeals = markWithExisitingSubscriptionId(_newMeals, ["entrée"], entreeSubscriptionId);
    }

    return _newMeals;
  };

  //Mark all new meals with existing typed subscription Id
  const markWithExisitingSubscriptionId = (mealsArr, typeArr, subscriptionId) => {
    let markedMeals = [...mealsArr];

    markedMeals.forEach((meal) => {
      meal.tags.forEach((tag) => {
        let mealTag = tag.toLowerCase();
        typeArr.forEach((type) => {
          if (mealTag === type && typeof meal.subscriptionId === "undefined") meal.subscriptionId = subscriptionId;
          if (mealTag === type && typeof subscriptionId === "undefined") meal.subscriptionId = null;
        });
      });
    });

    return markedMeals;
  };

  //Mark with subscriptionId=null if no subscription Id existed
  const markWithNull = (mealsArr, typeArr) => {
    let markedMeals = [...mealsArr];

    markedMeals.forEach((meal) => {
      meal.tags.forEach((tag) => {
        let mealTag = tag.toLowerCase();
        typeArr.forEach((type) => {
          if (mealTag === type) meal.subscriptionId = null;
        });
      });
    });

    return markedMeals;
  };

  //Final Checkup
  const checkUp = () => {
    if (mealsBreakdown.breakfasts === 0 && savedMealsBreakdown.breakfasts > 0) {
      newMeals = markWithNull(newMeals, ["breakfast"]);
    }

    if (mealsBreakdown.entrees === 0 && savedMealsBreakdown.entrees > 0) {
      newMeals = markWithNull(newMeals, ["entrée"]);
    }
    if (mealsBreakdown.addIns === 0 && savedMealsBreakdown.addIns > 0) {
      newMeals = markWithNull(newMeals, ["add-in"]);
    }
  };

  markNewMealsSubscriptionId(newMeals);
  checkUp();

  return newMeals;
};

/**
 * Bubble up SKU fields for new meals
 * @param {array} meals
 */
export const bubbleUpSKU = (meals) => {
  let newMeals = [...meals];

  newMeals.forEach((meal) => {
    meal.tags.forEach((tag) => {
      let mealTag = tag.toLowerCase();
      if (mealTag === "breakfast" || mealTag === "entrée") {
        meal.sku = meal.variants[0].sku;
      }
    });
  });

  return newMeals;
};

/**
 * Filter out irrelevant old orders in order not to show
 * orders with the date of a week ago
 * @param {array} orders
 */
export const filterOutOrders = (orders) => {
  const dateNow = Date.parse(new Date());
  return orders.filter((order) => {
    let processedAt = new Date(order.processedAt);
    processedAt.setDate(processedAt.getDate() + ((1 + 7 - processedAt.getDay()) % 7) + 6);
    processedAt = Date.parse(processedAt);

    return processedAt >= dateNow ? true : false;
  });
};

/**
 * Get Shopify assets url to add it as a root for the images, icons
 */
export const getAssetsUrl = () => {
  let assetsFaviconUrl = typeof window.mealSettings.assetsFaviconUrl !== "undefined" ? window.mealSettings.assetsFaviconUrl : FAVICON;

  return assetsFaviconUrl.split("favicon.")[0];
};

/**
 * Add image patrameter to reduce image width with container width
 * @param {string} imgSrc
 * @param {number} width
 */
export const cropImageSize = (imgSrc, width) => {
  let url = "";
  const prefixPng = "_" + width + "x.png";
  const prefixJpg = "_" + width + "x.jpg";
  const prefixJpeg = "_" + width + "x.jpeg";
  if (imgSrc.includes(".png")) {
    url = imgSrc.replace(/.png/gi, prefixPng);
  } else if (imgSrc.includes(".jpg")) {
    url = imgSrc.replace(/.jpg/gi, prefixJpg);
  } else if (imgSrc.includes(".jpeg")) {
    url = imgSrc.replace(/.jpeg/gi, prefixJpeg);
  } else {
    url = imgSrc;
  }

  return url;
};

/**
 * Sort tag icons to make icon-diet_ values be the first elements in array
 * @param {array} iconsUrls
 */
export const sortDietIcons = (iconsUrls) => {
  if (!iconsUrls.length) return [];

  return iconsUrls.sort((a, b) => {
    if (a.tag.includes("icon-diet")) {
      return -1;
    } else if (b.tag.includes("icon-diet")) {
      return 1;
    } else {
      return 0;
    }
  });
};

/**
 * Check if LocalStorage available
 */
export const storageAvailable = () => {
  let storage;
  try {
    storage = window["localStorage"];
    var x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" ||
        // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    );
  }
};

/**
 * Returns stock status of meal item
 * @param {array} iconsUrls
 * @param {string} id
 * @param {number} mealBoughtQuantity
 * @param {number} stockCapacity
 * @param {number} quantity
 * @param {object} charge
 */
export const isMealSoldCheck = (data) => {
  let { id, mealBoughtQuantity, stockCapacity, quantity, charge } = data;
  let _charge = { ...charge };
  let quantitySelected = quantity;

  //check initial selected value
  let findCurrentIdQuantity = (meals, productId) => {
    let q = 0;
    let product = meals.find((meal) => meal.id === productId);
    if (typeof product !== "undefined") {
      q = product.quantity;
    }
    return q;
  };

  let _stockCapacity = parseInt(stockCapacity);
  let _mealBoughtQuantity = parseInt(mealBoughtQuantity);
  let _availableQuantity = 0;

  if (typeof _charge === "undefined" || typeof _charge.meals === "undefined") {
    _availableQuantity = _stockCapacity - _mealBoughtQuantity - quantitySelected;
  } else {
    let _selectedItemQuantity = findCurrentIdQuantity(_charge.meals, id);

    _availableQuantity = _stockCapacity - _mealBoughtQuantity + _selectedItemQuantity - quantitySelected;
  }

  return _stockCapacity === 0 || _availableQuantity < 0 ? true : false;
};

export const getCurrentDietType = (deliveryDietType) => {
  switch (deliveryDietType) {
    case "Mediterranean":
      return "Mediterranean Plan";
    case "Low-FODMAP":
      return "Low-FODMAP Plan";
    case "Diabetes-Friendly":
      return "Diabetes Plan";
    case "Gluten-Free":
      return "Gluten-Free Plan";
    case "Heart-Friendly":
      return "Heart-Friendly Plan";
    case "Carb-Conscious":
      return "Carb-Conscious Plan";
    case "B2B":
      return "B2B Plan";
    /* case "Care Meals":
      return "Care Plan"; */
    case "Care":
      return "Care Plan";
    case "GLP-1":
      return "GLP-1 Plan";
    default:
      return "Low-FODMAP Plan";
  }
};

export const getProductDietTypeFromSku = (sku) => {

  if(sku.startsWith("LF")) return "Low-FODMAP Plan";
  if(sku.startsWith("MD")) return "Mediterranean Plan";
  if(sku.startsWith("DF")) return "Diabetes Plan";
  if(sku.startsWith("GF")) return "Gluten-Free Plan";
  if(sku.startsWith("HF")) return "Heart-Friendly Plan";
  if(sku.startsWith("CC")) return "Carb-Conscious Plan";
  if(sku.startsWith("B2B")) return "B2B Plan";
  if(sku.startsWith("MCD")) return "Care Plan";
  if(sku.startsWith("GL")) return "GLP-1 Plan";

  return "Low-FODMAP Plan";
};

export const logTimes = (id, phase, actualTime, baseTime, startTime, commitTime) => {
  console.log(`${id}'s ${phase} phase:`);
  console.log(`Actual time: ${actualTime}`);
  console.log(`Base time: ${baseTime}`);
  console.log(`Start time: ${startTime}`);
  console.log(`Commit time: ${commitTime}`);
  console.log(`========================`);
};

export const getMealsData = async (mealConstructorCollections) => {
  setDefaultUser();

  let constructorData = null;
  let error = {
    message: "",
  };

  const {id, email} = window.shopifyUser,
    mealCollectionId = mealConstructorCollections.mealsCollectionId;

  const url = CryptoTool.cryptUrl(`${shopUrl}/api/products?&mealCollectionId=${mealCollectionId}&customer_id=${id}`, email);

  try {
    constructorData = await API.get(url);
    constructorData = constructorData.data;
  } catch (err) {
    error = {
      message: "Network error. Please, refresh the page.",
      err,
    };
  }

  return {
    constructorData,
    error,
  };
};

export const isNoQuantityMode = function (data) {
  if (typeof data.definedLimit === "undefined") return false;
  return data.definedLimit ? false : true;
};

export const selectedBreakfastsCounter = (selectedMeals) => {
  let count = 0;
  selectedMeals.breakfasts.forEach((item) => {
    count += item.quantity;
  });

  return count;
};

export const selectedEntreesCounter = (selectedMeals) => {
  let count = 0;
  selectedMeals.entrees.forEach((item) => {
    count += item.quantity;
  });

  return count;
};

export function populateMealTypes(selectedMeals) {
  let itemsInCart = 0;

  selectedMeals.breakfasts.forEach(function (meal) {
    itemsInCart += meal.quantity;
  });

  selectedMeals.entrees.forEach(function (meal) {
    itemsInCart += meal.quantity;
  });

  return itemsInCart;
}


export const setDefaultUser = () => {
  if (typeof window.shopifyUser === "undefined") {
    window.shopifyUser = DefaultUser;
  }
}

//Add redirection from accont/login to checkout page if login was from checkout!!!
export function redirectFromCheckout() {
  const searchCustomParam = localStorage.getItem("SearchCustomParam");
  if (searchCustomParam && searchCustomParam.includes('checkout_url')) {
      const urlRedirection = decodeURIComponent(searchCustomParam).split('checkout_url=')[1];
      localStorage.removeItem("SearchCustomParam");
      window.location.href = urlRedirection;
  } else if (searchCustomParam) {
      localStorage.removeItem("SearchCustomParam");
  }
}
 